const getRoomPopup = (state) => state.get('roomPopup');
export const getRoomPopupIsOpened = (state) =>
  getRoomPopup(state).get('isOpened');
export const getRoomPopupPackageId = (state) =>
  getRoomPopup(state).get('packageId');
